'use es6';

import I18n from 'I18n';
export const getHistoryFormattedTimestamp = timestamp => timestamp ? I18n.moment.userTz(timestamp).format('LT') : null;
export const getVerboseHistoryFormattedTimestamp = timestamp => timestamp ? I18n.moment.userTz(timestamp).format('ddd, MMM Do, YYYY h:mm A') : null;